function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-edit",
  "data-name": "Icon feather-edit",
  transform: "translate(-2.25 -2.068)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9380",
  "data-name": "Path 9380",
  d: "M11.733,6H4.941A1.941,1.941,0,0,0,3,7.941V21.525a1.941,1.941,0,0,0,1.941,1.941H18.525a1.941,1.941,0,0,0,1.941-1.941V14.733",
  transform: "translate(0 -1.124)",
  fill: "none",
  stroke: "#393939",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9381",
  "data-name": "Path 9381",
  d: "M22.188,3.421A2.058,2.058,0,0,1,25.1,6.332L15.881,15.55,12,16.52l.97-3.881Z",
  transform: "translate(-3.178)",
  fill: "none",
  stroke: "#393939",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

function SvgFeatherEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.024,
    height: 21.024,
    viewBox: "0 0 21.024 21.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherEdit);
export default __webpack_public_path__ + "static/media/feather-edit.0a5475bc.svg";
export { ForwardRef as ReactComponent };